import { api } from './index.js';

/**
 * Adds the annotation polygon to the detections.geojson files on s3
 *
 * @async
 * @param {Object} params - The parameters for adding an annotation.
 * @param {string} params.projectUuid - The UUID of the project.
 * @param {string} params.filename - The name of the file to add the annotation.
 * @param {string} params.classname - The class name for the annotation.
 * @param {string} params.classid - The class ID for the annotation.
 * @param {string} params.modelUuid - The UUID of the model.
 * @param {Array|Object} params.polygon - The normalized polygon data for the annotation.
 * @returns {Promise<Object>} The data returned from the API.
 */
export const addAnnotationS3 = async ({
	projectUuid,
	filename,
	classname,
	classid,
	modelUuid,
	polygon,
}) => {
	const { data } = await api.post(`/annotations/add_point_px`, {
		project_uuid: projectUuid,
		model_uuid: modelUuid,
		filename,
		classname,
		classid,
		polygon,
	});

	return data;
};

/**
 * Deletes an annotation from the detections.geojson files on s3
 *
 * @async
 * @param {Object} params - The parameters for deleting an annotation
 * @param {string} params.projectUuid - UUID of the project
 * @param {string} params.modelUuid - UUID of the model
 * @param {string} params.annotationUuid - UUID of the annotation to be deleted
 * @returns {Promise<Object>} The data returned from the API.
 */
export const deleteAnnotationS3 = async ({ projectUuid, modelUuid, annotationUuid }) => {
	const { data } = await api.delete(`/annotations/${projectUuid}/${modelUuid}/${annotationUuid}`);
	return data;
};
